// Standard colours a branch can pick for its invoices (ezp_expense_centers.invoice_color).
// The colour is the invoice table header and totals bar, which carry white text, so
// every entry is dark enough to read it. The API accepts any #rrggbb; the first
// entry is the default it falls back to when a branch has none.
export const INVOICE_COLORS = [
  { label: "Crimson", value: "#c9194a" },
  { label: "Navy", value: "#1f3a5f" },
  { label: "Royal Blue", value: "#1d4ed8" },
  { label: "Teal", value: "#0f766e" },
  { label: "Green", value: "#15803d" },
  { label: "Orange", value: "#c2410c" },
  { label: "Purple", value: "#6d28d9" },
  { label: "Charcoal", value: "#374151" },
];

export const DEFAULT_INVOICE_COLOR = INVOICE_COLORS[0].value;
